import React, { useContext, useRef, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import { Container } from "reactstrap";
import { Transition } from 'react-transition-group';


import AbstractPlusScatter from "../../Abstracts/AbstractPlusScatter";
import { ThemeContext } from "../../context/ThemeContext";
import spiderImage from "assets/img/homepage/employer/top_job_boards.png";
import JobcaseLogo from "components/JobcaseLogo2";
import useIsInViewport from "ui/hooks/inViewport";

const logoDuration = 800;
const imagesDuration = 1400;

const defaultLogoStyle = {
    transition: `all ${logoDuration}ms ease-in-out`,
    height: 0,
    width: 0,
    opacity: 0,
    top: "50%",
    left: "50%"
}
const finalLogoStyle = {
    entering: {
        height: 0,
        width: 0,
        opacity: 0.5
    },
    entered: {
        height: "auto",
        width: "30%",
        opacity: 1,
        top: '40%',
        left: '35%'
    },
    exiting: {
        height: "auto",
        width: "30%",
        opacity: 0.5
    },
    exited: {
        height: 0,
        width: 0,
        opacity: 0
    }
}

const defaultImagesStyle = {
    transition: `all ${imagesDuration}ms ease-in-out`,
    height: 0,
    width: 0,
    top: "50%",
    left: "50%",
    opacity: 0,
}

const finalImagesStyle = {
    entering: {
        height: 0,
        width: 0,
        opacity: 0.2
    },
    entered: {
        height: "auto",
        width: "100%",
        opacity: 1,
        top: 0,
        left: 0
    },
    exiting: {
        opacity: 0.5
    },
    exited: {
        height: 0,
        width: 0,
        opacity: 0,
        top: "50%",
        left: "50%",
    }
}

const PostToBoards = (props) => {
    const postToBoardsRef = useRef(null);
    const context = useContext(ThemeContext);
    const [logoInView, logoToWatch] = useIsInViewport();
    const [imagesInView, imagesToWatch] = useIsInViewport();
    let scrollTimeout = null;

    useEffect(() => {
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }
        if (props.location.hash === "#postBoards") {
            scrollTimeout = setTimeout(() => {
                window.scrollTo(0, postToBoardsRef.current.offsetTop - 100);
            }, 10);
        }
        return () => {
            if (scrollTimeout) {
                clearTimeout(scrollTimeout);
            }
        }
    }, [props.location, postToBoardsRef]);

    return (
        <section id="postBoards" ref={postToBoardsRef} className={"upward_post_boards " + (context ? "upward_post_boards_" + context : "")} >
            <Container>
                <div className="clearfix">
                    {!props.pricing && <h2>Post to 100+ top job sites<br />with one click</h2>}
                    {props.pricing && <h3 className="text-center">Let us do the heavy lifting or <br /> you take the wheel</h3>}
                    <div className="top_board_image_holder text-center">
                        <div className="position-relative d-inline-block" style={{ "maxWidth": "800px" }}>
                            <AbstractPlusScatter className="board_abstract_bg" wrapperSize={{}} count={25} ></AbstractPlusScatter>
                            <Transition in={imagesInView} timeout={800} >
                                {transitionState => (
                                    <img ref={imagesToWatch} style={{ ...defaultImagesStyle, ...finalImagesStyle[transitionState] }} src={spiderImage} className="board_image" alt="Logo" />
                                )}
                            </Transition>
                            <Transition in={logoInView} timeout={20} >
                                {transitionState => (
                                    <div ref={logoToWatch} style={{ ...defaultLogoStyle, ...finalLogoStyle[transitionState] }} className="top_board_logo"><JobcaseLogo /></div>
                                )}
                            </Transition>
                            <img style={{ "visibility": "hidden", "maxWidth": "100%" }} src={spiderImage} alt="Spider"/>
                        </div>
                    </div>
                    {props.pricing && <div className="text-center take_the_wheel">
                        <p>Sponsor your job with Upward and let us find the right place for your job to appear.</p>
                        <p>Or, you can choose specific job sites like Ziprecruiters, Monster, Careerbuilder, and more.</p>
                        <Link to="/employers/?register=y" className="btn btn-xl btn-block btn-dark-orange btn-rounded">Create an account</Link>
                    </div>}
                </div>
            </Container>
        </section>
    )

}

export default withRouter(PostToBoards);